import React, { useState } from 'react';
import axios from 'axios';
import { Box, TextField, Button, Typography, Paper } from '@mui/material';

function PredictionForm() {
  const [formData, setFormData] = useState({
    race_info: '',
    type_item: '',
    type_horse: '',
    payment: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // await axios.post("http://127.0.0.1:8000/api/yosou_regist", formData);
      await axios.post('/api/yosou_regist', formData);
      setFormData({
        race_info: '',
        type_item: '',
        type_horse: '',
        payment: '',
      });
      alert('送信完了！');
    } catch (err) {
      console.error('送信エラー:', err);
      alert('送信に失敗しました');
    }
  };

  return (
    <Paper elevation={3} sx={{ maxWidth: 500, mx: 'auto', p: 3, mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        競馬予想 登録フォーム
      </Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          label="会場名"
          name="race_info"
          value={formData.race_info}
          onChange={handleChange}
          placeholder="例: 東京11R"
          fullWidth
          required
          margin="normal"
        />
        <TextField
          label="券種"
          name="type_item"
          value={formData.type_item}
          onChange={handleChange}
          placeholder="例: 馬連"
          fullWidth
          required
          margin="normal"
        />
        <TextField
          label="買い方"
          name="type_horse"
          value={formData.type_horse}
          onChange={handleChange}
          placeholder="例: 1-3,4"
          fullWidth
          required
          margin="normal"
        />
        <TextField
          label="金額"
          name="payment"
          value={formData.payment}
          onChange={handleChange}
          placeholder="例: 1000"
          fullWidth
          required
          margin="normal"
        />
        <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
          送信
        </Button>
      </Box>
    </Paper>
  );
}

export default PredictionForm;
